"use client";

import { useAuth } from "@clerk/nextjs";
import Link from "next/link";

import { css } from "@/../styled-system/css";
import useGetCartProducts from "@/app/hooks/useGetCartData";
import ShoppingCart from "@/assets/svg/shopping-cart.svg";
import { useCartStore } from "@/providers/cart-store-providers";

const cartIconDotClass = css({
  position: "absolute",
  backgroundColor: "red.500",
  minWidth: "16px",
  maxWidth: "32px",
  height: "16px",
  rounded: "full",
  bottom: "0px",
  right: "0px",
  textAlign: "center",
  userSelect: "none",
  color: "white",
  fontSize: "xs",
  lineHeight: "16px",
});

interface CartButtonProps {
  cartCount: number;
}

function CartButton({ cartCount }: CartButtonProps) {
  const { isSignedIn } = useAuth();
  const { data } = useGetCartProducts();
  const { cartItemsCount } = useCartStore((state) => state);

  // Ensure safe fallback for cartCountLocal
  let cartCountLocal = cartCount ?? 0;

  // Ensure API data is always treated as an array
  const safeData = Array.isArray(data) ? data : [];

  // Calculate total quantity safely
  if (safeData.length > 0) {
    cartCountLocal = safeData.reduce(
      (acc, item) => acc + (item?.quantity ?? 0),
      0,
    );
  }

  return (
    <Link
      className={css({
        position: "relative",
        textAlign: "center",
        display: "flex",
        cursor: "pointer",
        minWidth: "32px",
        minHeight: "32px",
      })}
      href="/cart"
      aria-label="Go to cart"
      prefetch={true}
    >
      <ShoppingCart width={42} stroke="black" />

      {isSignedIn && cartCountLocal > 0 && (
        <span className={cartIconDotClass}>
          {cartItemsCount ?? cartCountLocal}
        </span>
      )}
    </Link>
  );
}

export default CartButton;
